<template>
  <div class="add-block">
    <span>Редактирование деревьев{{ selectedTreeList[0].damages }}</span>
    <div class="grid">
      <div class="species-block">
        <span class="double-col label">Порода</span>
        <div class="flex-container">
          <custom-p-select
            v-model="editedTree.species"
            :options="speciesList"
            class="double-col input-species"
          />
          <button @click="openAddSpeciesBlock">+</button>
        </div>
        <AddSpeciesBlock
          v-if="addSpeciesIsOpen"
          @close="closeAddSpeciesBlock"
        />
      </div>

      <div>
        <span class="label" style="display: block;">Ярус</span>
        <p-dropdown
            v-model="editedTree.layer"
            :options="layerList"
            class="p-inputtext-sm"
            optionLabel="name" 
            optionValue="value"
        />
        <!--<input v-model="editedTree.layer" class="custom-input" /> -->
      </div>

      <div>
        <span class="label">Возрастное поколение</span>
        <input v-model="editedTree.gen" class="custom-input" />
      </div>

      <div v-if="lpo.inspection_type_id === '2'">
        <span class="label">Площадь сечения, кв.м</span>
        <custom-p-select
          v-model="editedTree.s_05"
          :options="info_s_05"
          :option-label="null"
          :data-key="null"
        />
      </div>

      <div v-else>
        <span class="label">Диаметр, см</span>
        <input v-model="editedTree.d" class="custom-input" />
      </div>

      <div>
        <span class="label">Категория состояния</span>
        <custom-p-select
          v-model="editedTree.state_cat"
          :options="info_state_cat"
        />
      </div>
    </div>

    <div class="nonliquid-block">
      <div class="nonliquid-block__checkbox-container">
        <custom-p-checkbox
          v-model="editedTree.is_liquid"
          label="Дерево ликвидно"
        />
      </div>

      <div v-if="!editedTree.is_liquid" class="nonliquid-reason-block">
        <span class="label">Причина неликвидности</span>
        <custom-p-select
          v-model="editedTree.nonliquid_reason"
          :options="info_nonliquid_reasons"
        />
      </div>
    </div>

    <div class="grid damage-block">
      <div>
        <span class="label">Причина повреждения</span>
        <custom-p-select
          v-model="selectedReason"
          :options="reasonList"
          :disabled="
            !editedTree.state_cat ||
              (editedTree.state_cat &&
                (editedTree.state_cat.id === '1' || !editedTree.state_cat.id))
          "
        />
      </div>
      <div>
        <span class="label">Признаки повреждения</span>
        <custom-p-select
          v-model="selectedSymptoms"
          :options="symptomList"
          multiple
          :disabled="
            !editedTree.state_cat ||
              (editedTree.state_cat &&
                (editedTree.state_cat.id === '1' || !editedTree.state_cat.id))
          "
        />
      </div>

      <div class="damage-list double-col">
        <template v-if="editedTree.damages.length">
          <div class="label">Выбранные повреждения</div>

          <div
            v-for="damage in groupedDamages"
            class="damage-list__damage-item"
          >
            <button
              @click="onRemoveDamageClick(damage)"
              class="damage-list__remove-btn"
            >
              <fa-icon icon="times" />
            </button>
            <div @click="onDamageClick(damage)" class="damage-list__damage-str">
              {{ damage.damageStr }}
              <!-- <fa-icon icon='mouse-pointer' style='margin-left: 1rem'/> -->
            </div>
          </div>

          <!-- <span>{{ editedTree.damages.map(damage => damage.reason_id + '(' + damage.symptom_id + ')').join(', ') }}</span> -->
        </template>
      </div>
    </div>

    <div class="add-btn-row">
      <button class="double-col" @click="close">Закрыть</button>
      <button class="double-col" @click="save" >Сохранить</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import AddSpeciesBlock from "./Recount__treesAddTaxSpecies";

const info_s_05 = [0.5, 1];

export default {
  name: "TreeListInstrumentalAddBlock",
  components: {
    AddSpeciesBlock,
  },
  props: {
    selectedPlot: {
      type: Object,
      default: null,
    },
    selectedTreeList: {
      type: Array,
    },
  },
  data() {
    return {
      editedTree: {
        species: null,
        layer: null,
        gen: null,
        d: null,
        s_05: null,
        state_cat: null,

        is_liquid: true,
        nonliquid_reason: null,

        damages: [],
      },

      selectedReason: null,
      selectedSymptoms: [],

      addSpeciesIsOpen: false,

      speciesChangedProgrammatically: false,
      stateCatChangedProgrammatically: false,
      isLiquidChangedProgrammatically: false,

      info_s_05,
    };
  },
  computed: {
    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },
    selectedSpecies() {
      return this.editedTree.species;
    },
    selectedStateCat() {
      return this.editedTree.state_cat;
    },
    selectedIsLiquid() {
      return this.editedTree.is_liquid;
    },

    ...mapState("selectedLpo/recount", {
      speciesList: (state) => state["speciesList"],
      reasonList: (state) => state["damageReasonList"],
      symptomList: (state) => state["damageSymptomList"],
      plotList: (state) => state["plotList"]
    }),

    ...mapState({
      info_nonliquid_reasons: (state) =>
        state.catalogs["info_nonliquid_reasons"],
      info_state_cat: (state) => state.catalogs["info_state_cat"],
    }),
    ...mapState("common", {
      layerList: (state) => state.layerList,
      genList: (state) => state.genList,
    }),
    groupedDamages() {
      const result = [];

      for (const damage of this.editedTree.damages) {
        let findedDamage = result.find(
          (item) => item.reason_id === damage.reason_id
        );

        if (!findedDamage) {
          const temp = {
            reason_id: damage.reason_id,
            reason: damage.reason,
            symptoms: [],
          };

          findedDamage = temp;

          result.push(findedDamage);
        }

        const temp = {
          damage_id: damage.id,
          symptom_id: damage.symptom_id,
          symptom: damage.symptom,
        };

        findedDamage.symptoms.push(temp);

        const damageStr =
          findedDamage.reason_id +
          "(" +
          findedDamage.symptoms
            .map((symptom) => symptom.symptom_id)
            .join(", ") +
          ")";
        findedDamage.damageStr = damageStr;
      }

      return result;
    },
  },
  watch: {
    selectedIsLiquid(is_liquid) {
      if (this.isLiquidChangedProgrammatically) {
        this.isLiquidChangedProgrammatically = false;
      } else {
        this.editedTree.nonliquid_reason = null;
      }
    },

    selectedSpecies(species) {
      if (this.speciesChangedProgrammatically) {
        this.speciesChangedProgrammatically = false;
      } else {
        this.editedTree.damages = [];
      }
      // this.editedTree.damages = [];
      this.selectedReason = null;
      this.selectedSymptoms = [];
      this.clearDamageReasonList();
      this.clearDamageSymptomList();

      if (!species) {
        return;
      }
      this.getDamageReasonList(species.id);
    },
    selectedStateCat(stateCat) {
      if (this.stateCatChangedProgrammatically) {
        this.stateCatChangedProgrammatically = false;
      } else {
        this.editedTree.damages = [];
      }
      // this.editedTree.damages = [];
      this.selectedReason = null;
      this.selectedSymptoms = [];
      this.clearDamageSymptomList();
    },
    selectedReason(reason) {
      this.clearDamageSymptomList();

      if (!reason) {
        this.selectedSymptoms = [];
        return;
      }
      if (this.editedTree.state_cat) {
        const temp = {
          state_cat_id: this.editedTree.state_cat.id,
          reason_id: reason.id,
        };
        this.getDamageSymptomList(temp);

        /* form selectedSymptoms */
        const resultSymptoms = [];

        for (const damage of this.editedTree.damages) {
          if (damage.reason_id !== reason.id) {
            continue;
          }

          resultSymptoms.push({ id: damage.symptom_id, name: damage.symptom });
        }

        this.selectedSymptoms = resultSymptoms;
      }
    },

    selectedSymptoms(symptoms) {
      if (!this.selectedReason) {
        return;
      }

      /* удаление повреждений из списка дерева */
      let damages = this.editedTree.damages;

      const damagesForRemove = [];
      for (const damage of damages) {
        if (damage.reason_id !== this.selectedReason.id) {
          continue;
        }
        if (
          !symptoms.find(
            (symptom) =>
              this.selectedReason.id === damage.reason_id &&
              symptom.id === damage.symptom_id
          )
        ) {
          damagesForRemove.push(damage);
        }
      }

      this.editedTree.damages = damages.filter((damage) => {
        return !damagesForRemove.includes(damage);
      });

      /* добавление повреждений в спискок дерева */
      damages = this.editedTree.damages;

      for (const symptom of symptoms) {
        if (
          !damages.find(
            (damage) =>
              damage.symptom_id === symptom.id &&
              damage.reason_id === this.selectedReason.id
          )
        ) {
          const temp = {
            reason: this.selectedReason.name,
            reason_id: this.selectedReason.id,
            symptom: symptom.name,
            symptom_id: symptom.id,
          };
          damages.push(temp);
        }
      }
    },
  },
  methods: {
    onDamageClick(groupedDamage) {
      if (this.selectedReason?.id === groupedDamage.reason_id) {
        return;
      }

      this.selectedReason = {
        id: groupedDamage.reason_id,
        name: groupedDamage.reason,
      };
    },

    onRemoveDamageClick(groupedDamage) {
      if (this.selectedReason?.id === groupedDamage.reason_id) {
        this.selectedReason = null;
        this.selectedSymptoms = [];
      }

      for (const symptom of groupedDamage.symptoms) {
        const findedIndex = this.editedTree.damages.findIndex(
          (damage) => damage.id === symptom.damage_id
        );
        if (findedIndex !== -1) {
          this.editedTree.damages.splice(findedIndex, 1);
        }
      }
    },

    openAddSpeciesBlock() {
      this.addSpeciesIsOpen = true;
    },
    closeAddSpeciesBlock() {
      this.addSpeciesIsOpen = false;
    },

    close() {
      this.$emit("close");
    },

    save() {
      // console.log(JSON.stringify(this.editedTree, null, 2));
      // return;
      if (this.editedTree.layer === null || this.editedTree.layer === "") {
        console.log("no layer");
        return;
      }
      if (this.editedTree.gen === null || this.editedTree.gen === "") {
        console.log("no gen");
        return;
      }
      if (
        (this.editedTree.d === null || this.editedTree.d === "") &&
        this.lpo.inspection_type_id !== "2"
      ) {
        console.log("no d");
        return;
      }

      if (
        (this.editedTree.s_05 === null || this.editedTree.s_05 === "") &&
        this.lpo.inspection_type_id === "2"
      ) {
        console.log("no s_05");
        return;
      }

      if (!this.editedTree.species) {
        console.log("no species");
        return;
      }
      if (!this.editedTree.state_cat) {
        console.log("no state_cat");
        return;
      }

      if (!this.editedTree.is_liquid && !this.editedTree.nonliquid_reason) {
        console.log("no nonliquid_reason");
        return;
      }

      if (!this.selectedPlot) {
        console.log("no selected plot");
        return;
      }

      const plot_id = this.selectedPlot.id;

      const temp = {
        plot_id: plot_id,
        selectedTreeList: this.selectedTreeList,
        editedTree: this.editedTree,
      };

      this.editTree(temp).then((res) => {
        this.$emit("edited-success");
        //this.updateTreeListOfPlot(plot_id);
        this.getTreeList(this.plotList);
        this.updatePlotList(this.lpo.lpo_id);

        // Обновление списка главных причин
        this.getMainDamageReasonList().then((res) => {
          return this.getSelectedMainDamageReasonList();
        });
      });
    },

    resetValues() {
      const selectedTree = this.selectedTreeList[0];
      // console.log('selectedTree: ', selectedTree);
      const state_cat = this.info_state_cat.find(
        (cat) => cat.id === selectedTree.state_cat_id
      );

      this.speciesChangedProgrammatically = true;
      this.stateCatChangedProgrammatically = true;
      this.isLiquidChangedProgrammatically = true;

      this.editedTree.species = {
        id: selectedTree.species_id,
        name: selectedTree.species,
      };
      this.editedTree.layer = parseInt(selectedTree.layer);
      this.editedTree.gen = selectedTree.gen;
      this.editedTree.d = selectedTree.d;
      this.editedTree.state_cat = state_cat;
      this.editedTree.s_05 = +selectedTree.s_05;

      this.editedTree.is_liquid = selectedTree.is_liquid;
      this.editedTree.nonliquid_reason = {
        id: selectedTree.nonliquid_reason_id,
        name: selectedTree.nonliquid_reason,
      };

      this.editedTree.damages = JSON.parse(
        JSON.stringify(selectedTree.damages)
      );
    },

    ...mapMutations("selectedLpo/recount", [
      "clearDamageReasonList",
      "clearDamageSymptomList",
    ]),

    ...mapActions("selectedLpo/recount", [
      "getTreeList",
      "updatePlotList",
      "getDamageReasonList",
      "getDamageSymptomList",
      "editTree",
      "getSpeciesList",
      "getMainDamageReasonList",
      "getSelectedMainDamageReasonList",
    ]),
  },

  created() {
    this.getSpeciesList(this.lpo.lpo_id);
    this.$store
      .dispatch("loadCatalogs", ["info_state_cat", "info_nonliquid_reasons"])
      .then((res) => {
        this.resetValues();
      });
  },
};
</script>

<style scoped src="@/style/grid.css"></style>
<style scoped src="@/style/flex.css"></style>
<style scoped src="@/style/input.css"></style>

<style scoped>
.damage-list__damage-item {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0.4rem 0;
}

.damage-list__damage-str {
  border: 1px solid transparent;
  padding: 0.4rem;
  cursor: pointer;
}

.damage-list__damage-str:hover {
  background-color: #ccc;
  border: 1px solid #aaa;
  padding: 0.4rem;
  cursor: pointer;
}
</style>

<style scoped>
.grid {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.label {
  font-weight: bold;
}

.add-block {
  background-color: #eee;
  border: 1px solid black;
  padding: 20px;

  /*width: 240px;*/
}

.damage-block {
  margin-top: 50px;
}

.add-btn-row {
  margin-top: 20px;
}
/*.add-block {
		border: 1px solid black;
		padding: 20px;
		width: 240px;
	}

	.grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 4px;
	}

	.double-col {
		grid-column: span 2;
	}*/
.species-block {
  position: relative;
  /*display: flex;*/
}

.input-species {
  flex: 1;
}

.add-species-block-outer {
  display: none;
  background-color: white;
  border: 1px solid black;
  padding: 20px;
  position: absolute;
  right: 0;
  z-index: 10;
}
.add-species-block.open {
  display: block;
}

.nonliquid-block__checkbox-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
.p-dropdown {
 min-width: 160px;
}
</style>
